import {
  Button,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Table,
  message,
  notification,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import dataInputAnaysis from "types/config/input-patientList.-config";
import "./PatientList.scss";
import {
  CalendarSVG,
  CalendarSelectedSVG,
  ExcelSVG,
  ListIconSVG,
} from "assets";
import { columnsTablePatientList } from "./PatientList.config";
import dataPatientList from "__mocks__/dataPatientList";
import { ColumnsType } from "antd/es/table";
import ColumnsDisplayPatientList from "./PopoverPatientList/PopoverPatientList";
import ExpandSearch from "components/common/ExpandSearch/ExpandSearch";
import { analysisService } from "api";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey, setIdPhieuKham } from "redux/reducer/common";
import { tabKeys } from "types/enums";
import { catalogService } from "api";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import { TableRowSelection } from "antd/es/table/interface";
import { ColumnPopoverDisplay, ListActionButton } from "components/common";
import { ColumnProps } from "types/models";
import { medicalExaminationService } from "api";
import dayjs from "dayjs";
import {
  setIdSecond,
  setIdXetNghiem,
  setTGChiDinh,
} from "redux/reducer/reduxCommon";
import Notification from "components/common/notification/notification";
import ModalPrint from "../DetailInfo/ModalPrint/ModalPrint";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";

const PatientList = () => {
  let savedTableOption = getTableOptions(
    "ANALYSIS_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columnsTablePatientList.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsTablePatientList;
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter((e) => e.show == true)
  );
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [ttPhieuXN, setTTPhieuXn] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);
  const [dataFields, setDataFields] = useState(dataInputAnaysis);
  const expandRef = useRef<any>();
  const dispatch = useAppDispatch();
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 50,
    ngayTaoDen: dayjs(),
    ngayTaoTu: dayjs(),
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [listIdPrint, setListIdPrint] = useState([]);
  const activeTab = useAppSelector((state) => state.common.activeTab);

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayTaoTu: formatDateToString(params.ngayTaoTu),
      ngayTaoDen: formatDateToString(params.ngayTaoDen),
    };
  };

  useEffect(() => {
    getListPatientAnalysis();
  }, [currentPage, params, callApi, activeTab]);

  useEffect(() => {
    getListKhuKham();
    getListLoaiKCB();
    getListStatusXN();
  }, [callApi]);

  const getListPatientAnalysis = async () => {
    // console.log('dsadsadas', formatParams());
    setLoading(true);
    try {
      const response = await analysisService
        .getListTabAnalysis(formatParams())
        .then((res) => {
          // console.log("res danh sach xet nghiem", res);
          const newData = res.data.data.map((item) => ({
            ...item,
            key: item.id,
            maBenhNhan: item.maBenhNhan,
            idPhieuKham: item.idPhieuKham,
            maPhieuChiDinh: item.idPhieuChiDinh,
            tenBenhNhan: item.hoTen,
            gioiTinh: item.gioiTinh,
            ngaySinh: item.ngaySinh,
            ngayTao: item.thoiGianKham,
            diaChi: item.diaChiTongHop,
            loaiKhamChuaBenh: item.khuKham,
            bacSiChiDinh: item.bacSyChiDinh,
            trangThaiXetNghiem: item.trangThai,
            dienThoai: item.dienThoai,
            loaiBenhNhans: item.loaiBenhNhans,
          }));
          setData(newData);
          setLoading(false);
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
    } catch (error) {
      setLoading(false);
      // Notification("error", "Đã có lỗi xảy ra khi lấy danh sách xét nghiệm");
    }
  };

  const renderLoaiKCB = (listKCB) => {
    columns.find((e) => e.dataIndex == "loaiKhamChuaBenh").render = (
      v,
      r,
      i
    ) => {
      let textKCB = listKCB.find((e) => e.id == v)?.tenLoaiKCB;
      return <KCBTypeColumn label={textKCB}></KCBTypeColumn>;
    };
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setParams({
      ...params,
      page: page,
      limit: pageSize,
    });
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    showSizeChanger: true,
    pageSize: params.limit,
    onChange: handlePaginationChange,
  };

  columns.map((e) => {
    if (e.key == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });

  columns.find((e) => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => handleDelete(_record.key)}
        printFunction={() => handlePrint(_record.key)}
        editFunction={() => handleEdit(_record)}
      ></ListActionButton>
    );
  };

  const handleDelete = async (id) => {
    try {
      const response = await analysisService
        .deleteTicketAnalysis(id)
        .then((res) => {
          // notification.success({message: "Thao tác thành công"});
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi xoá");
    }
    getListPatientAnalysis();
  };

  const handleEdit = (record) => {
    //  console.log('id in', record.key);
    disPath(setIdPhieuKham(record.idPhieuKham));
    disPath(setTGChiDinh(record.thoiGianChiDinh));
    dispatch(setActiveKey(tabKeys.ANALYSIS.DETAIL_PATIENT_ANALYSIS));
    dispatch(setIdXetNghiem(record.key));
  };

  const handlePrint = (id) => {
    // console.log('id in', id);
    dispatch(setIdSecond(id));
    setListIdPrint([]);
    setIsShowModalPrint(true);
  };

  const disPath = useAppDispatch();
  const handleRowClick = (record) => {
    // console.log("Dữ liệu hàng:", record);
    disPath(setIdPhieuKham(record.idPhieuKham));
    disPath(setIdXetNghiem(record.key));
    disPath(setTGChiDinh(record.thoiGianChiDinh));
    disPath(setActiveKey(tabKeys.ANALYSIS.DETAIL_PATIENT_ANALYSIS));
    // setIsTabDisabled(false);
  };

  const getListLoaiKCB = async () => {
    try {
      const res = await catalogService.getListLoaiKCB();

      dataFields.find((e) => e.name == "loaiKCB").options = res.map((e) => {
        return { value: e.id, label: e.tenLoaiKCB };
      });

      columns.find((e) => e?.dataIndex == "loaiKhamChuaBenh").render = (
        v,
        r,
        i
      ) => {
        const kcb = res.find((e) => e?.id == v)?.tenLoaiKCB;
        return <>{kcb}</>;
      };
      renderLoaiKCB(res);
      setDataFields([...dataFields]);
    } catch (error) {
      // Notification(
      //   "error",
      //   "Đã có lỗi xảy ra khi lấy danh sách loại khám chữa bệnh"
      // );
    }
  };

  const getListStatusXN = async () => {
    try {
      let response = await medicalExaminationService.getListTTPhieuKham({
        page: 1,
        limit: 100,
      });
      setTTPhieuXn(response.data);
    } catch (err) {
      // Notification(
      //   "error",
      //   "Đã có lỗi xảy ra khi lấy danh sách trạng thái xét nghiệm"
      // );
    }
  };

  const getListKhuKham = async () => {
    try {
      const res = await catalogService.getListKhuKham();
      dataFields.find((e) => e.name == "khuKham").options = res.map((e) => {
        return { value: e.id, label: e.tenKhuKham };
      });
      setDataFields([...dataFields]);
    } catch (error) {
      // Notification("error", "Đã có lỗi xảy ra khi lấy danh sách khu khám");
    }
  };

  const onClickSearchButton = async () => {
    let searchFields = expandRef.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 });
  };

  const onSelectChange = (selectedRowKeys: React.Key[], selections) => {
    // console.log('dữ liệu radio xet nghiem',selections);
    setSelectedRowKeys(selectedRowKeys);
    disPath(setIdPhieuKham(selections[0].idPhieuKham));
    disPath(setIdXetNghiem(selectedRowKeys[0]));
  };

  const rowRadio: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: "radio",
  };

  const onToday = (key: number) => {
    setLoading(true);

    setParams({ ...params, ngayTaoDen: dayjs(), ngayTaoTu: dayjs() });

    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setLoading(true);
    setParams({
      ...params,
      // comboboxNgay: 2,
      ngayTaoDen: dayjs().subtract(1, "day"),
      ngayTaoTu: dayjs().subtract(1, "day"),
    });

    setSelectedBtn(key);
  };

  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];

  // const setShowColumns = (showColumns) => {
  //   setColumns(showColumns);
  // };

  // const onReset = () => {
  //   const newData = {
  //     limit: 10,
  //     comboboxNgay: params.comboboxNgay,
  //     ngaySinh: formatDateToString(params.ngaySinh),
  //     ngayTaoTu: formatDateToString(params.ngayTaoTu),
  //     ngayTaoDen: formatDateToString(params.ngayTaoDen),
  //   };
  //   setParams(
  //     newData
  //   );
  // }

  const onKeyDown = (e) => {
    if (e.key == "Enter") {
      onClickSearchButton();
    }
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "ANALYSIS_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  // const rowSelection = {
  //   onChange: (selectedRowKeys: React.Key[], selections) => {
  //     console.log('dsadsadas',selectedRowKeys);
  //     console.log('dsadsadas',selections[0].idPhieuKham);

  //     disPath(setIdPhieuKham(selections[0].idPhieuKham));
  //     setSelectedRowKeys(selectedRowKeys);
  //     disPath(setIdXetNghiem(selectedRowKeys[0]));
  //   },
  // };

  return (
    <Spin spinning={loading}>
      <div className="patientList-container" onKeyDown={onKeyDown}>
        <div className="container layout-first">
          <Space direction="vertical" style={{ width: "100%" }}>
            <ExpandSearch
              fields={dataFields}
              onClickSearch={onClickSearchButton}
              ref={expandRef}
              onReset={onClickSearchButton}
              initialValues={params}
            ></ExpandSearch>
          </Space>
        </div>
        <div className="container layout-second">
          <Row
            style={{ marginBottom: "10px" }}
            justify={"end"}
            gutter={[16, 8]}
          >
            <Space wrap className="group-button">
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}
              {/* <Button icon={<ExcelSVG />} className="custom-btn">
              Xuất báo cáo
            </Button> */}
              <Popover
                trigger="click"
                placement="bottomLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
            </Space>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            // className="custom-resize-table-scroll"
            bordered
            // scroll={{ x: '100%', y: 500 }}
            pagination={paginationConfig}
            dataSource={data}
            columns={columns}
            rowSelection={rowRadio}
            // rowSelection={{
            //   type: "radio",
            //   ...rowSelection,
            // }}
            onRow={(record) => ({
              onDoubleClick: () => handleRowClick(record),
            })}
          />
        </div>
        <ModalPrint
          isShowModal={isShowModalPrint}
          handleOk={handleOpen}
          handleCancel={handleCancelPrint}
          listId={listIdPrint}
        />
      </div>
    </Spin>
  );
};

export default PatientList;
